import * as React from 'react'

import { getNestedObject } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'

import {
  BlogLayout,
  CmsSeo,
  ContentLayout,
  DefaultPageProps,
  getContentByRef,
} from '@grandvision/bloomreach'

import Layout from '../../components/Layout'

const { publicRuntimeConfig } = getConfig()

const HandleLayout = (type: string, props: any): React.ReactNode => {
  switch (type) {
    case 'blogArticle':
      return <BlogLayout {...props} />
    case 'contentDocument':
      return <ContentLayout {...props} />
    default:
      return <ContentLayout {...props} />
  }
}

const ContentPage = ({ pageModel, asPath, preview, isSolaris, labels }: DefaultPageProps) => {
  if (!pageModel || !pageModel.page || pageModel.page.components.length === 0) {
    console.error(`No pageModel or components found for path: ${asPath}!`)
    return null
  }

  const main = pageModel.page.components.find((comp) => comp.name === 'main')
  const configuration = main ? main.components.find((comp) => comp.name === 'content') : {}
  const contentRef = getNestedObject(configuration, ['models', 'document', '$ref'])

  if (!configuration || !contentRef) {
    console.error('No configuration or components found for NotificationBar in CMS model!')
    return null
  }

  const content = getContentByRef(contentRef, pageModel)
  const seoConfig = main ? main.components.find((comp) => comp.name === 'seo') : {}
  const pageName = pageModel.page.name

  return (
    <React.Fragment>
      <CmsSeo configuration={seoConfig} pageModel={pageModel} preview={!!preview} />

      <Layout pageModel={pageModel} asPath={asPath} isSolaris={isSolaris} preview={preview}>
        {HandleLayout(content.type, { content, pageModel, labels, publicRuntimeConfig, pageName })}
      </Layout>
    </React.Fragment>
  )
}

ContentPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, isSolaris, preview } = query as any

  return {
    asPath,
    pageModel,
    preview,
    isSolaris,
  }
}

export default ContentPage
